import React, { Component } from "react";
import moment from "moment-jalaali";
import { constantApp } from "../../../../config/constant";
import PropTypes from "prop-types";
const axios = require("axios");

class Consult extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newCustomer: {
        DateSabt: moment().format("jYYYY/jMM/jDD"),
        TimeSabt: moment().format("HH:mm"),
        namFamil: "",
        email: "",
        mobile: "",
        typeBusiness: 1,
      },

      ErrorCustomer: {
        namFamil: false,
        email: false,
        mobile: false,
        typeBusiness: false,
      },
      isSaving: false,
    };

    this.initialState = { ...this.state };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.timer = this.timer.bind(this);
  }

  InsertConsult = (
    DateSabt,
    TimeSabt,
    namFamil,
    mobile,
    email,
    typeBusiness
  ) => {
    let params = {
      DateSabt: DateSabt,
      TimeSabt: TimeSabt,
      namFamil: namFamil,
      mobile: mobile,
      email: email,
      typeBusiness: typeBusiness,
    };

    let url = `${constantApp.SERVERIP}:${constantApp.PORT_APPACHE}/PHP/Consult/Insert.php`;

    axios.post(url, params);
    // .then(function (response) {
    //     return response.data;
    // })
    // .catch(function (error) {

    // });
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    const { DateSabt, TimeSabt, namFamil, mobile, email, typeBusiness } =
      this.state.newCustomer;

    if (namFamil.trim() === "") {
      this.setState({ ErrorCustomer: { namFamil: true } });
      return;
    }

    if (mobile.trim() === "") {
      this.setState({ ErrorCustomer: { mobile: true } });
      return;
    } else if (mobile.trim().length < 9) {
      this.setState({ ErrorCustomer: { mobile: true } });
      return;
    }

    let emailValid = email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
    if (email.trim() === "" || emailValid === null) {
      this.setState({ ErrorCustomer: { email: true } });
      return;
    }

    if (typeBusiness === 1) {
      this.setState({ ErrorCustomer: { typeBusiness: true } });
      return;
    }

    await this.InsertConsult(
      DateSabt,
      TimeSabt,
      namFamil,
      mobile,
      email,
      typeBusiness
    );

    this.setState(this.initialState);
    this.setState({ isSaving: true });
  };

  handleChange(e) {
    // let target = e.target;
    // let value = target.type === 'checkbox' ? target.checked : target.value;
    // let name = target.name;

    // this.setState({
    //     [name]: value
    // });

    let value = e.target.value;

    let name = e.target.name;

    this.setState(
      (prevState) => ({
        ErrorCustomer: { ...prevState.ErrorCustomer, [name]: false },
        newCustomer: { ...prevState.newCustomer, [name]: value },
      }),
      () => null
    );
  }

  isError() {
    if (
      this.state.ErrorCustomer.namFamil === true ||
      this.state.ErrorCustomer.mobile === true ||
      this.state.ErrorCustomer.email === true ||
      this.state.ErrorCustomer.typeBusiness === true
    ) {
      return true;
    } else {
      return false;
    }
  }

  timer() {
    if (this.state.isSaving) {
      this.setState({ isSaving: false });
    }
  }

  componentDidMount() {
    this.intervalId = setInterval(this.timer.bind(this), 8000);
  }
  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  render() {
    return (
      <section
        className={
          this.props.BackgroundVisible
            ? "contact-section section-padding parallax"
            : "section-padding parallax"
        }
        data-bg-image={
          this.props.BackgroundVisible
            ? "assets/images/contact-section-bg.jpg"
            : null
        }
      >
        <div className="container">
          <div className="row">
            <div className="col col-md-4 col-md-offset-1 col-md-5">
              <div className="contact-section-contact-box">
                <div
                  className={
                    this.props.BackgroundVisible
                      ? "section-title-white"
                      : "section-title"
                  }
                >
                  <h2>تماس</h2>
                </div>
                <div className="details">
                  <p>برای هر نوع پرس و جو، با راه های زیر تماس بگیرید.</p>
                  <ul>
                    <li
                      style={{
                        color: this.props.BackgroundVisible ? "#FFF" : "gray",
                      }}
                    >
                      <span className="fa fa-phone"></span> ۰۳۵-۳۷۲۶۳۳۲۱
                    </li>
                    <li
                      style={{
                        color: this.props.BackgroundVisible ? "#FFF" : "gray",
                      }}
                    >
                      <span className="fa fa-envelope"></span> info@apafan.com
                    </li>
                    <li
                      style={{
                        color: this.props.BackgroundVisible ? "#FFF" : "gray",
                      }}
                    >
                      <span className="fa fa-home"></span> یزد، خیابان شهید
                      مطهری، مرکز فناوری اقبال، سالن موسسات، واحد C5
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col col-lg-6 col-lg-offset-1 col-md-7">
              <div
                className={
                  this.props.BackgroundVisible
                    ? "section-title-white"
                    : "section-title"
                }
              >
                <h2>درخواست مشاوره</h2>
              </div>
              <p>جهت تعیین وقت مشاوره حضوری لطفا فرم زیر را تکمیل نمایید.</p>

              <div className="contact-form-s1 form">
                <form
                  id="contact-form"
                  className="wpcf7-form contact-validation-active"
                  onSubmit={this.handleSubmit}
                  noValidate
                >
                  <div>
                    <label htmlFor="namFamil">نام کامل</label>
                    <input
                      style={{
                        border: this.state.ErrorCustomer.namFamil
                          ? "2px solid red"
                          : null,
                      }}
                      type="text"
                      name="namFamil"
                      value={this.state.newCustomer.namFamil}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div>
                    <label htmlFor="email">ایمیل</label>
                    <input
                      style={{
                        border: this.state.ErrorCustomer.email
                          ? "2px solid red"
                          : null,
                      }}
                      type="email"
                      name="email"
                      value={this.state.newCustomer.email}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div>
                    <label htmlFor="mobile">شماره موبایل</label>
                    <input
                      style={{
                        border: this.state.ErrorCustomer.mobile
                          ? "2px solid red"
                          : null,
                      }}
                      type="number"
                      name="mobile"
                      value={this.state.newCustomer.mobile}
                      onChange={this.handleChange}
                      min="0"
                    />
                  </div>
                  <div>
                    <label>زمینه مورد نظر</label>
                    <select
                      defaultValue="1"
                      name="typeBusiness"
                      style={{
                        border: this.state.ErrorCustomer.typeBusiness
                          ? "2px solid red"
                          : null,
                      }}
                      onChange={this.handleChange}
                      value={this.state.newCustomer.typeBusiness}
                    >
                      <option disabled value="1">
                        {" "}
                        -- یکی را انتخاب کنید--{" "}
                      </option>
                      <option value="2">بافندگی</option>
                      <option value="3">چله کشی</option>
                      <option value="4">رنگرزی</option>
                      <option value="5">تولید نخ</option>
                      <option value="6">کنترل کیفیت و پردازش نخ</option>
                    </select>
                  </div>

                  <div className="submit-btn-wrap">
                    <input
                      value="ارسال"
                      className="theme-btn wpcf7-submit"
                      type="submit"
                    />

                    <div id="loader">
                      <i className="fa fa-refresh fa-spin fa-3x fa-fw"></i>
                    </div>
                  </div>
                  <div className="error-handling-messages">
                    <div
                      id="success"
                      style={{
                        display: this.state.isSaving ? "block" : "none",
                      }}
                    >
                      با سپاس از شما
                    </div>
                    <div
                      id="error"
                      style={{ display: this.isError() ? "block" : "none" }}
                    >
                      لطفا فیلدها را تکمیل نمایید
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div className="contact-women wow fadeInLeft">
          <img
            src="assets/images/contact-women.png"
            alt=""
            role="presentation"
          />
        </div>
      </section>
    );
  }
}

Consult.propTypes = {
  BackgroundVisible: PropTypes.bool,
};

export default Consult;
